import apiClient from '@/services/apiClient';

const base = '/tissue-jw';
const d = (p) => p.then((r) => r.data);

export const searchSorts = (q) => d(apiClient.get(`${base}/sorts`, { params: { q } }));
export const createOrder = (body) => d(apiClient.post(`${base}/orders`, body));
export const listOrders = (params = {}) => d(apiClient.get(`${base}/orders`, { params }));
export const getOrder = (jwId) => d(apiClient.get(`${base}/orders/${jwId}`));
export const cancelOrder = (jwId, reason) => d(apiClient.post(`${base}/orders/${jwId}/cancel`, { reason }));
export const acceptOrder = (jwId) => d(apiClient.post(`${base}/orders/${jwId}/accept`));
export const rejectOrder = (jwId, reason) => d(apiClient.post(`${base}/orders/${jwId}/reject`, { reason }));
export const pickBundle = (jwId, code) => d(apiClient.post(`${base}/orders/${jwId}/pick`, { bundle_code: code }));
export const unpickBundle = (jwId, code) => d(apiClient.post(`${base}/orders/${jwId}/unpick`, { bundle_code: code }));
export const transferOrder = (jwId) => d(apiClient.post(`${base}/orders/${jwId}/transfer`));
export const inwardEntries = () => d(apiClient.get(`${base}/inward-entries`));
export const receivePacks = (jwId, body) => d(apiClient.post(`${base}/orders/${jwId}/receive`, body));
export const closeOrder = (jwId, reason) => d(apiClient.post(`${base}/orders/${jwId}/close`, { reason }));
export const printPacks = (jwId, receiptId) => d(apiClient.get(`${base}/orders/${jwId}/print-packs`, { params: { receipt_id: receiptId } }));
export const packStock = () => d(apiClient.get(`${base}/packs/summary`));

export const errText = (e, fallback = 'Something went wrong') => {
  const det = e?.response?.data?.detail;
  return typeof det === 'string' ? det : fallback;
};
